import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'


import Input from '../ui/Input';
import Button from '../ui/Button';
import textError from './textError'
import Checkbox from '../ui/Checkbox'
import { BaloonInc } from './statusForms/image';
import { idField, translateFields } from '../utils/localCatalog';
import { checkNotEmptyValue } from '../utils/utils';
import { sendAnalyticsEventToNative } from '../utils/analytics';

const ch = value => {
  if(value === undefined)
    return true
  return value.length !== 0
}

const formatData = data => (data && data.length) ? data.split('@')[0] : ''
const formatStateCode = data => {
  if(data)
    return `${data.slice(0, 5)} ${data.slice(5,)}`
  return ''
}
const checkTypeDevice = () => {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
    if(navigator.userAgent.indexOf('Android') !== -1)
      return 'android'
    else if(navigator.userAgent.indexOf('iPhone') !== -1)
      return 'iphone'
  }
  return ''
}
const checkFormatDate = () => checkTypeDevice() === 'iphone' ? 'YYYY-MM-DD' : 'DD.MM.YYYY'
class GeneralInformation extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      data: {
        firstName: props.userData.firstName || '',
        surName: props.userData.surName || '',
        patronymic: props.userData.patronymic || '',
        stateCode: formatStateCode(props.userData.stateCode) || '',
        dateBirthday: props.userData.dateBirthday ?
          moment(formatData(props.userData.dateBirthday)).format(checkFormatDate()) : ''
      },
      isPatronymic: ch(props.userData.patronymic),
      nextForm: false,
      errorValid: false,
      errorStateCode: false,
      typeDevice: checkTypeDevice()
    }
    this.formRef = React.createRef()
    this.ignoreValidation = ch(props.userData.patronymic) ?  [] : ['patronymic'] 
    this.notSaveData = false
  }

  componentDidMount(){
    sendAnalyticsEventToNative('ecoCreditCardOrderStep1')
  }

  componentWillUnmount(){
    const formData = {}
    const {data, nextForm, isPatronymic} = this.state
    if(!nextForm){
      formData.name = data.firstName
      formData.surname =  data.surName 
      formData.patronymicName = isPatronymic ? data.patronymic : ''
      formData.stateCode = data.stateCode.replace(' ', '')
      formData.birthDay = moment(data.dateBirthday.split('.').reverse().join('-')).format('YYYY-MM-DD@HH:mm:ss')
      if(parseInt(data.stateCode.replace(' ', '')[8])%2 === 0)
        formData.sex = 2
      else
        formData.sex = 1
      if(!this.notSaveData){
        this.props.onSubmitData(formData, true)
      }
    }
  }

  sendHistory = (e) => {
    const {userData } = this.props
    const name = e.target.name
    const oldValue = userData[name]
    
    let value = e.target.value

    if(name === 'dateBirthday') {
      if(value !== '') {
        value = moment(value.split('.').reverse().join('-')).format('YYYY-MM-DD@HH:mm:ss')
      }
    } 

    const revType = oldValue === undefined ? 1 : 2

    if(oldValue !== value && (revType === 1 ? checkNotEmptyValue(value) : true)) {
  
      this.props.sendHistory({
        revType,
        fieldId: idField[name],
        oldValue,
        newValue: value
      })

      this.props.onSubmitData({
        [translateFields[name]]: value
      }, true)
    }
  }

  checkChangePatronymic = (value, prevValue) => {
    if(value === prevValue) return prevValue
    return true
  }

  onChange = e => {
    let value
    if(e.target.name === 'dateBirthday')
      value = e.target.value
    else {
      const reg = /[-−–—'’`‘′А-Яа-яіЇє]/gi
      const checkReg = e.target.value.match(reg) || []
      const filter = checkReg.filter(item => !['ы','Ы','э','Э', 'ъ', "Ъ"].some(val => val === item)) || []
      value = filter.join('')      
    }
    this.setState({
      isPatronymic: e.target.name === 'patronymic'
        ? this.checkChangePatronymic(value, this.state.isPatronymic)
        : this.state.isPatronymic,
      data: {
        ...this.state.data,
        [e.target.name]: value
      },
      errorStateCode: (['stateCode', 'dateBirthday'].some(item => item === e.target.name )) ?
        false :
        this.state.errorStateCode
    })
  }
  onChangeNumber = e => {
    const reg = new RegExp(/^[0-9]{0,10}$/)
    let value
    const splitVal = e.target.value.replace(' ', '')
    if(splitVal.length <= 10 && splitVal.length >= 0){
      if(splitVal.length > 0)
        if(reg.test(splitVal)){
          if(splitVal.length <= 5){
            value = e.target.value
          } else if(splitVal.length > 5){
            value = `${splitVal.slice(0, 5)} ${splitVal.slice(5,)}`
          }
        } else {
          value = this.state.data[e.target.name]
        }
        // value = reg.test(e.target.value) ? e.target.value : 
      else
        value = '' 
      this.setState({
        data: {
          ...this.state.data,
          [e.target.name]: value.trim()
        },
        errorStateCode: (['stateCode', 'dateBirthday'].some(item => item === e.target.name )) ?
          false :
          this.state.errorStateCode
      })
    }
  }
  submit = e => {
    e.preventDefault()
    const checkInn = this.innValidation('stateCode', true)
    const checkDate = this.innValidation('dateBirthday', true)
    this.setState({
      errorStateCode: checkInn.length !== 0 
    })
    if(this.validation()
        && !checkInn.length
        && (this.state.typeDevice === 'iphone' ? true : this.validationDate())
        && !checkDate.length
      ){
      const formData = {}
      const {data, isPatronymic} = this.state
      if(parseInt(data.stateCode.replace(' ', '')[8])%2 === 0)
        formData.sex = 2
      else
        formData.sex = 1
      formData.name = data.firstName
      formData.surname =  data.surName 
      formData.patronymicName = isPatronymic ? data.patronymic : ''
      formData.stateCode = data.stateCode.replace(' ', '')
      formData.birthDay = moment(data.dateBirthday.split('.').reverse().join('-')).format('YYYY-MM-DD@HH:mm:ss')

      this.setState({nextForm: true}, () => this.props.onSubmitData(formData))
      
    } else
      this.setState({
        errorValid: true,
        errorStateCode: checkInn.length !== 0 
      })
    
  }
  checkInn = (name) => {
    const {dateBirthday, stateCode} = this.state.data
    const newForm = dateBirthday.split('.').reverse().join('-')
    const convertDateBirthday = moment(newForm).format('YYYY-MM-DD'); // mm-dd-YYYY
    const innToDate = moment('1899-12-31').add('days', parseInt(stateCode.slice(0, 5))).format('YYYY-MM-DD')
    if(innToDate !== convertDateBirthday)
      return `Перевірте правильність вводу ${name === 'stateCode' ? 'ІПН' : 'дати народження'}`
    return ''
  }
  validation = () => (
    Object.keys(this.state.data)
    .filter(itemFilter => !this.ignoreValidation.some(itemIgnore => itemFilter === itemIgnore))
    .every(item => this.state.data[item].length !== 0)
  )
  innValidation = (name, ignore) => {
    const {data, errorStateCode} = this.state
    if(data[name].length === 0)
      return name === 'stateCode' ? textError.emptyInn : textError.emptyDateBirthday
    else if(name === 'stateCode' && data[name].length < 11)
      return textError.smallInn
    else if(['stateCode', 'dateBirthday'].some(item => data[item].length === 0))
      return ''
    return (ignore ? true : errorStateCode) && this.checkInn(name)
  }
  validationDate = () => {
    var arrD = this.state.data.dateBirthday.split(".");
    arrD[1] -= 1;
    var d = new Date(arrD[2], arrD[1], arrD[0]);
    if ((d.getFullYear() == arrD[2]) && (d.getMonth() == arrD[1]) && (d.getDate() == arrD[0])) {
        return true;
    } else {
      return false;
    }
  }
  onCheck = () => {
    if(this.state.isPatronymic){
      this.ignoreValidation = ['patronymic']
    } else {
      this.ignoreValidation = []
    }
    this.setState({isPatronymic: !this.state.isPatronymic})

    const newValue = !this.props.userData.noPatronymic

    this.props.sendHistory({
      revType: this.props.userData.noPatronymic === undefined ? 1 : 2,
      fieldId: idField.noPatronymic,
      oldValue:  this.props.userData.noPatronymic,
      newValue: newValue
    })
    
    this.props.onSubmitData({ noPatronymic: newValue }, true)
  }
  onChangeCalendar = e => {
    const {value} = e.target
    const currentValue = this.state.data.dateBirthday
    const splitData = value.split('.').filter(val => val.length)
    const splitCurrentValue = currentValue.split('.').filter(val => val.length)
    const validValue = splitData.map((value, index) => {
      if(index === 0){
        if(parseInt(value) > 3 && parseInt(value) <= 9)
          return '0'+ parseInt(value)
        else if(value === '00')
          return '01'
        else if(parseInt(value) <= 31)
          return parseInt(value)
        return splitCurrentValue[0]
      } else if(index === 1){
        if(parseInt(value) > 3 && parseInt(value) <= 9)
          return '0' + parseInt(value)
        return parseInt(value)
      }

      return value
    })
    this.setState({
      data: {
        ...this.state.data,
        dateBirthday: validValue.join('.')
      }
    })
  }

  handleClickNotValidData = (e) => {
    e.preventDefault()
    this.notSaveData = true
    this.props.showNotValidForm()
  }
  render(){
    const {errorValid, data, errorStateCode, isPatronymic, typeDevice} = this.state
    const {firstName, surName, patronymic, stateCode, dateBirthday } = data
    const {blockedFields, isClient} = this.props

    return(
      <form className="general-information" onSubmit={this.submit}>
        <div className="scroll-container">
          <div className="general-info">
            <Input
              name='surName'
              value={surName}
              onChange={this.onChange}
              onResetNumber={this.onResetNumber}
              placeholder='Наприклад  Петров'
              autoFocus={true}
              title='Прізвище'
              textValid={errorValid && (surName.length !== 0 ? '' : textError.obligatory)}
              maxLength={80}
              disabled={blockedFields.surname}
              onBlur={this.sendHistory}
            />
            <Input
              name='firstName'
              value={firstName}
              onChange={this.onChange}
              onResetNumber={this.onResetNumber}
              placeholder='Наприклад  Петро'
              title='Ім’я'
              textValid={errorValid && (firstName.length !== 0 ? '' : textError.obligatory)}
              maxLength={80}
              disabled={blockedFields.name}
              onBlur={this.sendHistory}
            />
            <Input
              name='patronymic'
              value={patronymic}
              onChange={this.onChange}
              onResetNumber={this.onResetNumber}
              placeholder='Наприклад  Петрович'
              title='По батькові'
              textValid={errorValid && isPatronymic && (patronymic.length !== 0 ? '' : textError.obligatory)}
              maxLength={80}
              disabled={blockedFields.patronymicName || !isPatronymic}
              onBlur={this.sendHistory}
            />
            <Checkbox
              id={'index'}
              name={`BRAND-all`}
              type='BRAND'
              onChange={patronymic.length ? null : this.onCheck}
              checked={!isPatronymic}
              itemForAll={true}
              value='По-батькові відсутнє '
              disabled={patronymic.length}
            />
            <Input
              name='stateCode'
              value={stateCode}
              onChange={this.onChangeNumber}
              onResetNumber={this.onResetNumber}
             /*  mask={[/\d/,/\d/, /\d/, /\d/, /\d/, ' ',/\d/,/\d/, /\d/, /\d/, /\d/]} */
              placeholder='11111 11111'
              title='Введіть ІПН (Ідентифікаційний код)'
              textValid={(errorStateCode || errorValid) && (this.innValidation('stateCode'))}
              type='tel'
              pattern='^[ 0-9]+$'
              novalidate="novalidate"
              keepCharPositions = {true}
              disabled={blockedFields.stateCode}
              onBlur={this.sendHistory}
            />
            {typeDevice === 'iphone' ? (
              <div className="data-container">
                <div className="title-container">
                  {BaloonInc}
                  <span className="title-text">Дата народження</span>
                </div>
                <input
                  type='date'
                  value={dateBirthday}
                  name='dateBirthday'
                  onChange={this.onChange}
                  max={moment().subtract(18, 'y').format('YYYY-MM-DD')}
                  min='1900-01-01'
                  disabled={blockedFields.dateBirthday}
                  onBlur={this.sendHistory}
                />
                {<span className='error-message'>
                  {(errorStateCode || errorValid) && (this.innValidation('dateBirthday'))}
                </span>}
              </div>
            ) : (
              <div className="data-container dateBirthday">
                <div className="title-container">
                  {BaloonInc}
                  <span className="title-text">Дата народження</span>
                </div>
                <Input
                  name='dateBirthday'
                  value={dateBirthday}
                  onChange={this.onChange}
                  // onResetNumber={this.onResetNumber}
                  className='calendar'
                  mask={[/\d/,/\d/, '.', /\d/, /\d/, '.',/\d/,/\d/, /\d/, /\d/]}
                  placeholder='dd.mm.yyyy'
                  // textValid={(errorStateCode || errorValid) && (this.innValidation('stateCode'))}
                  typeMask='tel'
                  pattern='^[.0-9]+$'
                  disabled={blockedFields.birthDay}
                  onBlur={this.sendHistory}
                />
                {errorValid && !this.validationDate() && dateBirthday.length !== 0 && 
                  <span className='error-message'>
                    {textError.errorFormatDate}
                  </span>}
                {<span className='error-message'>
                  {(errorStateCode || errorValid) && (this.innValidation('dateBirthday'))}
                </span>}
              </div>
             )}
            
          </div>
          <div className='button-container-footer'>
            <Button
              type='submit'
              title={isClient ? 'Підтвердити правильність даних та перейти далі' : 'Далі'}
              color={this.validation() ? 'success' : 'disable'}
            />
            {isClient && <Button
              type='button'
              title='Не підтверджую  правильність введених даних'
              color={'success'}
              onClick={this.handleClickNotValidData}
            />}
          </div>
        </div>
      </form>
    )
  }
}

GeneralInformation.propTypes = {
  onSubmitData: PropTypes.func.isRequired,
  userData: {
    firstName: PropTypes.string,
    surName: PropTypes.string,
    patronymic: PropTypes.string,
    stateCode: PropTypes.string,
    dateBirthday: PropTypes.string,
  },
  showNotValidForm: PropTypes.func.isRequired,
  blockedFields: PropTypes.object,
  isClient: PropTypes.bool,
  sendHistory: PropTypes.func.isRequired
}

export default GeneralInformation